(function() {
  'use strict';

  class ProductAddons {
    constructor() {
      this.mainVariantSelect = document.querySelector('[data-variant-select]');
      this.addToCartBtn = document.getElementById('add-to-cart-btn');
      this.totalPriceDisplay = document.getElementById('total-price-display');
      this.requiredBundle = document.querySelectorAll('.addon-variant-select[data-required="true"]');
      this.optionalBundle = document.querySelectorAll('.addon-variant-select[data-required="false"]');
      this.bundleChildrenInput = document.querySelector('input[name="properties[__bundle_children]"]');
      this.errorMessage = document.getElementById('error-message');
      this.clearMainBtn = document.getElementById('clear-main-variant');
      this.variantSelectionBanner = document.getElementById('variant-selection-banner');
      this.productVariantsData = null;
      this.addonVariantsData = {};
      this.defaultImage = null;
      this.defaultPrice = null;
      this.defaultComparePrice = null;
      this.defaultShortDescription = null;
      
      this.init();
    }

    init() {      
      if (!this.addToCartBtn) return;

      // Load product variants data
      this.loadVariantsData();

      // Event listeners
      this.addToCartBtn.addEventListener('click', () => this.handleAddToCart());  
      
      // Addon option selects (for multiple options)
      document.querySelectorAll('.addon-option-select').forEach(select => {
        select.addEventListener('change', (e) => this.handleAddonOptionChange(e));
      });

      // Addon variant selects (single option)
      this.requiredBundle.forEach(select => {
        if (select.tagName === 'SELECT') {
          select.addEventListener('change', (e) => {
            this.handleAddonVariantChange(e);
            this.updateBundleChildrenInput();
          }
        );
        }
      }); 

      // Optional addon variant selects
       this.optionalBundle.forEach(select => {
        if (select.tagName === 'SELECT') {
          select.addEventListener('change', (e) => {
            this.handleAddonVariantChange(e);
            this.updateBundleChildrenInput();
          }
        );
        }
      }); 

      // Clear addon buttons
      document.querySelectorAll('.btn-clear-addon').forEach(btn => {
        btn.addEventListener('click', (e) => this.clearAddon(e));
      });

      // Initial state
      this.updateTotalPrice();
      this.updateAddToCartButton();
      this.updateVariantSelectionBanner();
    }

    loadVariantsData() {       
      // Load addon variants
      document.querySelectorAll('.addon-variants-data').forEach(script => {
        const addonId = script.dataset.addonId;
        this.addonVariantsData[addonId] = JSON.parse(script.textContent);
      });  
    } 

    updateImage(imgElement, imageUrl) {
      if (!imgElement) return;
      
      imgElement.classList.add('updating');
      imgElement.src = imageUrl;
      imgElement.srcset = imageUrl;
      imgElement.classList.remove('updating');
    }    

    handleAddonOptionChange(event) {
      const select = event.target;
      const addonId = select.dataset.addonId;
      const isRequired = select.dataset.required === 'true';
      
      const selectedOptions = this.getSelectedOptions(
        `.addon-option-select[data-addon-id="${addonId}"]`
      );
      
      const variantsData = this.addonVariantsData[addonId];
      if (!variantsData) return;

      // Find matching variant
      const matchingVariant = variantsData.variants.find(variant => {
        return selectedOptions.every((value, index) => {
          const optionKey = `option${index + 1}`;
          return variant[optionKey] === value;
        });
      });

      const hiddenInput = document.querySelector(
        `.addon-variant-select[data-addon-id="${addonId}"]`
      );

      if (matchingVariant && hiddenInput) {
        hiddenInput.value = matchingVariant.id;
        hiddenInput.dataset.price = matchingVariant.price;
        
        // <CHANGE> Update addon price display
        this.updateAddonPriceDisplay(addonId, matchingVariant.price);
        
        // <CHANGE> Update addon image
        if (matchingVariant.image) {
          this.updateAddonImage(addonId, matchingVariant.image);
        }
        
        // Show clear button
        this.showAddonClearButton(addonId, isRequired);
      } else if (hiddenInput) {
        hiddenInput.value = '';
        
        // <CHANGE> Reset to default image and price if no options selected
        if (selectedOptions.length === 0) {
          this.resetAddonToDefaults(addonId);
          this.hideAddonClearButton(addonId, isRequired);
        }
      }

      this.updateTotalPrice();
      if (isRequired) {
        this.updateAddToCartButton();
        this.updateVariantSelectionBanner();
      }
    }

    handleAddonVariantChange(event) {
      const select = event.target;
      const addonId = select.dataset.addonId;
      const isRequired = select.dataset.required === 'true';
      const selectedOption = select.selectedOptions[0];
      const removeClass = document.querySelector(`.hide-default[data-addon-product-id="${addonId}"]`);
      
      if (selectedOption && selectedOption.value) {
        const price = selectedOption.dataset.price;
        const comparePrice = selectedOption.dataset.compareprice;
        const shortDescription = selectedOption.dataset.description;
        if (price) {
          select.dataset.price = price;
          this.updateAddonPriceDisplay(addonId, price);
        }
        if (comparePrice) {
          select.dataset.compareprice = comparePrice;
          this.updateAddonComparePriceDisplay(addonId, comparePrice);
        }
        if (shortDescription) {
          select.dataset.description = shortDescription;
          this.updateAddonShortDescriptionDisplay(addonId, shortDescription);
        }
        if (removeClass) {
          removeClass.classList.remove('hide-default');
        }
        
        // <CHANGE> Update addon image with variant image
        const imageUrl = selectedOption.dataset.image;
        if (imageUrl) {
          this.updateAddonImage(addonId, imageUrl);
        }
        
        // Show clear button
        this.showAddonClearButton(addonId, isRequired);
      } else {
        // <CHANGE> Reset to default image and price
        this.resetAddonToDefaults(addonId);
        
        // Hide clear button
        this.hideAddonClearButton(addonId, isRequired);
      }
      
      this.updateTotalPrice();
      if (isRequired) {
        this.updateAddToCartButton();
        this.updateVariantSelectionBanner();
      }
    }

    updateAddonImage(addonId, imageUrl) {
      const addonImage = document.getElementById(`addon-image-${addonId}`);
      if (addonImage) {
        this.updateImage(addonImage, imageUrl);
      }
    }

    resetAddonToDefaults(addonId) {
      const variantsData = this.addonVariantsData[addonId];
      const addClass = document.querySelector(`.bundle-as-variants[data-addon-product-id="${addonId}"]`);
      if (!variantsData) return;
      
      // <CHANGE> Reset image to default
      if (variantsData.defaultImage) {
        this.updateAddonImage(addonId, variantsData.defaultImage);
      }
      
      // <CHANGE> Reset price to default
      if (variantsData.defaultPrice) {
        this.updateAddonPriceDisplay(addonId, variantsData.defaultPrice);
      }

      // <CHANGE> Reset compare at price to default
      if (variantsData.defaultComparePrice) {
        this.updateAddonComparePriceDisplay(addonId, variantsData.defaultComparePrice);
      }

      // <CHANGE> Reset short description to default
      if (variantsData.defaultShortDescription) {
        function decodeHTML(html) {
          const txt = document.createElement('textarea');
          txt.innerHTML = html;
          return txt.value;
        }

        let decodedHTML = decodeHTML(variantsData.defaultShortDescription);

        decodedHTML = decodedHTML.replace(/<br\s*\/?>\s*<br\s*\/?>/gi, '<br />');

        this.updateAddonShortDescriptionDisplay(addonId, decodedHTML);
      }

      if (addClass && !addClass.classList.contains('hide-default')) {
        addClass.classList.add('hide-default');
      }
    }

    updateAddonPriceDisplay(addonId, price) {
      const priceDisplay = document.querySelector(`[data-addon-price="${addonId}"] .addOnPrice`);
      if (priceDisplay) {
        const formattedPrice = this.formatMoney(price);
        const prefix = priceDisplay.textContent.startsWith('+') ? '+' : '';
        priceDisplay.textContent = prefix + formattedPrice;
      }
    }

    updateAddonComparePriceDisplay(addonId, price) {
      const priceDisplay = document.querySelector(`[data-addon-price="${addonId}"] .addOnComparePrice`);
      if (priceDisplay) {
        const formattedPrice = this.formatMoney(price);
        const prefix = priceDisplay.textContent.startsWith('+') ? '+' : '';
        priceDisplay.textContent = prefix + formattedPrice;
      }
    }

    updateAddonShortDescriptionDisplay(addonId, shortDescription) {
      const shortDescriptionEl = document.querySelector(`.addon-info-decription[data-description-id="${addonId}"]`);
      if (shortDescriptionEl) {
        shortDescriptionEl.innerHTML = shortDescription;
      }
    }    

    showAddonClearButton(addonId, isRequired) {
      const clearBtn = document.querySelector(`.btn-clear-addon[data-addon-id="${addonId}"][data-required="${isRequired}"]`);
      const optionalContainer = document.querySelector(`.optional[data-addon-product-id="${addonId}"]`);
      const requiredPrice = document.querySelector(`.required[data-addon-product-id="${addonId}"] .addon-info-price`);

      if (clearBtn) {
        clearBtn.style.display = 'block';
      }

      if (optionalContainer) {
        optionalContainer.style.display = 'flex';        
      }

      if (requiredPrice) {
        requiredPrice.style.display = 'block';        
      }
    }

    hideAddonClearButton(addonId, isRequired) {
      const clearBtn = document.querySelector(`.btn-clear-addon[data-addon-id="${addonId}"][data-required="${isRequired}"]`);
      const optionalContainer = document.querySelector(`.optional[data-addon-product-id="${addonId}"]`);
      const requiredPrice = document.querySelector(`.required[data-addon-product-id="${addonId}"] .addon-info-price`);

      if (clearBtn) {
        clearBtn.style.display = 'none';        
      }

      if (optionalContainer) {
        optionalContainer.style.display = 'none';        
      }

      if (requiredPrice) {
        requiredPrice.style.display = 'none';        
      }

    }

    clearAddon(event) {
      const btn = event.target;
      const addonId = btn.dataset.addonId;
      const isRequired = btn.dataset.required === 'true';
      const optionalContainer = document.querySelector(`.optional[data-addon-product-id="${addonId}"]`);
      const requiredPrice = document.querySelector(`.required[data-addon-product-id="${addonId}"] .addon-info-price`);
      
      // Clear all option selects for this addon
      document.querySelectorAll(`.addon-option-select[data-addon-id="${addonId}"]`).forEach(select => {
        select.value = '';
      });
      
      // Clear variant select
      const variantSelect = document.querySelector(
        `.addon-variant-select[data-addon-id="${addonId}"]`
      );
      if (variantSelect && variantSelect.tagName === 'SELECT') {
        variantSelect.value = '';
      }
      
      // Clear hidden input
      if (variantSelect) {
        variantSelect.value = '';
      }
      
      // <CHANGE> Reset addon to default image and price
      this.resetAddonToDefaults(addonId);
      
      // Hide clear button
      btn.style.display = 'none';
      
      if (optionalContainer) {
        optionalContainer.style.display = 'none';        
      }

      if (requiredPrice) {
        requiredPrice.style.display = 'none';        
      }
      
      this.updateTotalPrice();
      if (isRequired) {
        this.updateAddToCartButton();
        this.updateVariantSelectionBanner();
      }
    }

    getSelectedOptions(selector) {
      const selects = document.querySelectorAll(selector);
      const options = [];
      
      selects.forEach(select => {
        if (select.value) {
          options.push(select.value);
        }
      });
      
      return options;
    }    

    updateTotalPrice() {
      const basePriceContainer = document.getElementById('main-product-form');
      let total = parseFloat(basePriceContainer.dataset.price);
      let totalComparePrice = parseFloat(basePriceContainer.dataset.compareprice);
      
      // Required addons
      this.requiredBundle.forEach(input => {
        const price = input.dataset.price;
        if (input.value && price) {
          total += parseFloat(price);
          const comparePrice = input.dataset.compareprice;
          if (comparePrice) {
            totalComparePrice += parseFloat(comparePrice);
          }
        }
      });

      // Optional addons
      this.optionalBundle.forEach(input => {
        const price = input.dataset.price;
        if (input.value && price) {
          total += parseFloat(price);
          const comparePrice = input.dataset.compareprice;
          if (comparePrice) {
            totalComparePrice += parseFloat(comparePrice);
          }
        }
      });

      // Format and display total
      this.totalPriceDisplay.textContent = this.formatMoney(total);
      
      // Display compare price if it's greater than regular price
      const totalComparePriceDisplay = document.getElementById('total-compare-price-display');
      if (totalComparePriceDisplay) {
        if (totalComparePrice > total) {
          totalComparePriceDisplay.textContent = this.formatMoney(totalComparePrice);
          totalComparePriceDisplay.style.display = 'inline';
        } else {
          totalComparePriceDisplay.style.display = 'none';
        }
      }
    }

    updateAddToCartButton() {
      let isValid = true;

      // Check main product variant
      if (this.mainVariantSelect && !this.mainVariantSelect.value) {
        isValid = false;
      }
      
      // Check required addons
      const requiredSelects = this.requiredBundle;
      requiredSelects.forEach(select => {
        if (!select.value) {
          isValid = false;
        }
      });

      // Check required addon options (multiple options)
      const requiredOptionSelects = document.querySelectorAll('.addon-option-select[data-required="true"]');
      requiredOptionSelects.forEach(select => {
        if (!select.value) {
          isValid = false;
        }
      });

      // Enable/disable button
      this.addToCartBtn.disabled = !isValid;
    }

    updateBundleChildrenInput() {      
      if (!this.bundleChildrenInput) return;
      const selectedAddonIds = Array.from(this.requiredBundle)
        .map((select) => select.value)
        .filter((value) => value !== '');
      this.bundleChildrenInput.value = `[${selectedAddonIds.join(',')}]`;
    }      

    async handleAddToCart() {
      this.hideError();
      
      // Validate and collect items
      const items = this.collectCartItems();
      
      if (!items) {
        return;
      }

      // Disable button during request
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.textContent = 'Adding...';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const data = await response.json();
        
        // Success! Redirect to cart
        window.location.href = '/cart';
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showError('Failed to add to cart. Please try again.');
        this.updateAddToCartButton();
        this.addToCartBtn.textContent = 'Add to Cart';
      }
    }

    /* collectCartItems() {
      const items = []; 
      const groupId = crypto.randomUUID();
      
      // Main product
      const mainVariantId = this.mainVariantSelect ? this.mainVariantSelect.value : null;
      if (!mainVariantId) {
        this.showError('Please select a product option');
        return null;
      }

      const requiredInputs = this.requiredBundle || [];
      const optionaldInputs = this.optionalBundle || [];

      const mainVariantItem = { 
        id: mainVariantId, 
        quantity: 1,
        properties: {
          bundle_id: groupId
        }
      };

      // Add properties from form
      const propertiesInputs = document.querySelector('form[action="/cart/add"]')?.querySelectorAll('input[name^="properties"]') || [];
      for( const input of propertiesInputs ) {
        const matching = input.name.match(/properties\[(.+?)\]$/);
        if( matching?.[1] ) mainVariantItem.properties[matching[1]] = input.value;
      }
      
      // Add main item
      items.push(mainVariantItem);

      // Required addons
      const requiredInputs = this.requiredBundle;
      for (const input of requiredInputs) {
        const variantId = input.value;
        if (!variantId) {
          this.showError('Please select all required add-on options');
          return null;
        }
        items.push({ 
          id: variantId, 
          quantity: 1,
          parent_id: mainVariantId,
          properties: {
            bundle_id: groupId
          }
        });
      }

      // Optional addons
      const optionaldInputs = this.optionalBundle;
      for (const optionalInput of optionaldInputs) {
        const optionalVariantId = optionalInput.value;
        if (optionalVariantId) {
          items.push({ 
          id: optionalVariantId, 
          quantity: 1,
          parent_id: mainVariantId,
          properties: {
            bundle_id: groupId
          }
        });
        }        
      }

      return items;
    } */

    collectCartItems() {
      const items = [];

      const mainVariantId = this.mainVariantSelect ? this.mainVariantSelect.value : null;
      if (!mainVariantId) {
        this.showError('Please select a product option');
        return null;
      }

      const requiredInputs = this.requiredBundle || [];
      const optionaldInputs = this.optionalBundle || [];

      // Check if bundle actually exists
      const hasRequired = requiredInputs.length > 0;
      const hasOptionalSelected = Array.from(optionaldInputs).some(input => input.value);

      const isBundle = hasRequired || hasOptionalSelected;

      // Only generate groupId if needed
      const groupId = isBundle ? crypto.randomUUID() : null;

      // Main product
      const mainVariantItem = { 
        id: mainVariantId, 
        quantity: 1
      };

      if (isBundle) {
        mainVariantItem.properties = { bundle_id: groupId };
      }

      // Add properties from form
      const propertiesInputs = document
        .querySelector('form[action="/cart/add"]')
        ?.querySelectorAll('input[name^="properties"]') || [];

      for (const input of propertiesInputs) {
        const matching = input.name.match(/properties\[(.+?)\]$/);
        if (matching?.[1]) {
          if (!mainVariantItem.properties) mainVariantItem.properties = {};
          mainVariantItem.properties[matching[1]] = input.value;
        }
      }

      items.push(mainVariantItem);

      // Required addons
      for (const input of requiredInputs) {
        const variantId = input.value;
        if (!variantId) {
          this.showError('Please select all required add-on options');
          return null;
        }

        const item = { 
          id: variantId, 
          quantity: 1,
          parent_id: mainVariantId
        };

        if (isBundle) {
          item.properties = { bundle_id: groupId };
        }

        items.push(item);
      }

      // Optional addons
      for (const optionalInput of optionaldInputs) {
        const optionalVariantId = optionalInput.value;

        if (optionalVariantId) {
          const item = { 
            id: optionalVariantId, 
            quantity: 1,
            parent_id: mainVariantId
          };

          if (isBundle) {
            item.properties = { bundle_id: groupId };
          }

          items.push(item);
        }
      }

      return items;
    }

    showError(message) {
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    }

    hideError() {
      this.errorMessage.style.display = 'none';
    }

    updateVariantSelectionBanner() {
      if (!this.variantSelectionBanner) return;

      const unselectedProducts = [];

      // Check required addon products with variants
      const requiredAddonItems = document.querySelectorAll('.required-products');
      
      requiredAddonItems.forEach(item => {
        const addonId = item.dataset.addonProductId;
        const productTitle = item.dataset.productTitle;
        
        // Check if this product has option selects (multiple options)
        const optionSelects = item.querySelectorAll(`.addon-variant-select[data-addon-id="${addonId}"][data-required="true"]`);
        
        if (optionSelects.length > 0) {
          // Has multiple option selects - check if any are not selected
          let hasUnselectedOption = false;
          optionSelects.forEach(select => {
            if (!select.value) {
              hasUnselectedOption = true;
            }
          });
          
          if (hasUnselectedOption) {
            unselectedProducts.push(productTitle);
          }
        } else {
          // Check if it has a variant select (single option or variant select)
          const variantSelect = item.querySelector(`.addon-variant-select[data-addon-id="${addonId}"][data-required="true"]`);
          
          // Only add if it's a SELECT element (has variants) and is not selected
          if (variantSelect && variantSelect.tagName === 'SELECT' && !variantSelect.value) {
            unselectedProducts.push(productTitle);
          }
        }
      });

      // Update banner display
      if (unselectedProducts.length > 0) {
        const messages = unselectedProducts.map(title => 
          `${title} → Please choose product options.`
        ).join('<br>');
        
        this.variantSelectionBanner.innerHTML = messages;
        this.variantSelectionBanner.style.display = 'flex';
      } else {
        this.variantSelectionBanner.style.display = 'none';
      }
    }

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductAddons());
  } else {
    new ProductAddons();
  }
})();